import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  signal,
} from '@angular/core';
import { ModalController } from '@ionic/angular';
import { InformationMessageType } from './information-message.type';

const messageTypeIconMap: Record<InformationMessageType, string> = {
  ['information']: 'information-circle-outline',
  ['success']: 'checkmark-circle-outline',
  ['warning']: 'warning',
  ['error']: 'alert-circle-outline',
};
const defaultMessageTypeIcon = messageTypeIconMap['information'];
const messageTypeColorMap = {
  ['information']: 'primary',
  ['success']: 'success',
  ['warning']: 'warning',
  ['error']: 'danger',
};
const defaultMessageTypeColor = messageTypeColorMap['information'];

@Component({
    selector: 'shared-information-message',
    templateUrl: './information-message.component.html',
    styleUrl: './information-message.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InformationMessageComponent {
  private readonly modalController = inject(ModalController);

  @Input() set type(type: InformationMessageType) {
    this.icon.set(messageTypeIconMap[type]);
    this.color.set(messageTypeColorMap[type]);
  }

  @Input() showCloseButton = false;
  @Input() message = '';
  readonly icon = signal(defaultMessageTypeIcon);
  readonly color = signal(defaultMessageTypeColor);

  close(): void {
    this.modalController.dismiss();
  }
}
